import {Directive, HostListener, Input} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {isEmpty, isString} from "lodash";

@Directive({
    selector: '[valuePattern][controlName][formGroup]'
})

export class InputPatternDirective {

    pattern = /^[a-zA-Z0-9\s(\-)+',.\/:]*$/;
    prevValue: string = '';
    @Input('controlName') controlName: string;
    @Input('formGroup') form: FormGroup;

    @Input('valuePattern')
    set newPattern(val) {
        if (isString(val) && !isEmpty(val)) {
            this.pattern = new RegExp(val);
        }
    }

    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent) {
        if (!this.pattern.test(event.clipboardData.getData('text'))) {
            event.preventDefault();
        }
    }

    @HostListener('keyup', ['$event'])
    onChanges(event) {
        let control = this.form.controls[this.controlName];
        let value = event.target.value;
        if (!value) {
            this.prevValue = value;
            control.patchValue(value);
            return;
        }
        if (value !== this.prevValue) {
            if (this.pattern.test(value)) {
                control.patchValue(value);
                this.prevValue = value;
            } else {
                control.patchValue(this.prevValue);
            }
        }

    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/input-modifiers/input-pattern.directive.ts